export function downloadFile(file, fileName) {
    const href = URL.createObjectURL(file);
    const downloadLink = document.createElement("a");
    downloadLink.href = href;
    downloadLink.download = fileName;
    downloadLink.click();
    URL.revokeObjectURL(href);
}
